import script from "./common-redirect-page.vue?vue&type=script&lang=ts&setup=true"
export * from "./common-redirect-page.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__